<template>
	<div>
		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0 card-list"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="8"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						cols="12"
						md="4"
						class="text-right"
					>
						<div>
							<b-button
								@click="openAssignResponsibleAreaModal()"
								variant="primary"
							>
								<span class="text-nowrap">Asignar Área Responsable</span>
							</b-button>
						</div>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refResponsibleAreasListTable"
				class="position-relative table-contracts"
				:style="'height: inherit'"
				:items="fetchResponsibleAreas"
				responsive
				:fields="tableColumns"
				primary-key="id2"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #head(department_name)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(has_mineras)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(has_conexas)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(createdAt)="data">
					<span v-html="data.label"></span>
				</template>

				<template #cell(department_name)="data">
					<div class="text-nowrap">{{ data.item.department_name }}</div>
				</template>

				<template #cell(indicator_name)="data">
					<div class="text-nowrap">{{ data.item.indicator_name }}</div>
				</template>

				<template #cell(has_mineras)="data">
					<div class="text-nowrap">
						<b-button
							:variant="`flat-${data.item.has_mineras ? 'success' : 'danger'}`"
							class="btn-icon rounded-circle"
						>
							<feather-icon :icon="data.item.has_mineras ? 'CheckCircleIcon' : 'XCircleIcon'" />
						</b-button>
					</div>
				</template>

				<template #cell(has_conexas)="data">
					<div class="text-nowrap">
						<b-button
							:variant="`flat-${data.item.has_conexas ? 'success' : 'danger'}`"
							class="btn-icon rounded-circle"
						>
							<feather-icon :icon="data.item.has_conexas ? 'CheckCircleIcon' : 'XCircleIcon'" />
						</b-button>
					</div>
				</template>

				<template #cell(createdAt)="data">
					<div class="text-nowrap">{{ formatStringToDate(data.item.createdAt) }}</div>
				</template>

				<template #cell(actions)="data">
					<b-dropdown
						variant="link"
						no-caret
						:right="$store.state.appConfig.isRTL"
					>
						<template #button-content>
							<feather-icon
								icon="MoreVerticalIcon"
								size="16"
								class="align-middle text-body"
							/>
						</template>

						<b-dropdown-item @click="openAssignResponsibleAreaModal(true, data.item)">
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Editar</span>
						</b-dropdown-item>

						<b-dropdown-item @click="deleteResponsibleArea(data.item.id)">
							<feather-icon icon="TrashIcon" />
							<span class="align-middle ml-50">Eliminar</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalResponsibleAreas"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>

		<b-modal
			ref="refAssignResponsibleAreaModal"
			title="ASIGNACIÓN DE ÁREA RESPONSABLE"
			title-tag="div"
			header-bg-variant="primary"
			header-text-variant="white"
			no-close-on-backdrop
			hide-header-close
			no-close-on-esc
			centered
		>
			<validation-observer ref="refForm">
				<b-form>
					<b-col
						cols="12"
						class="my-2"
					>
						<b-form-group>
							<label for="responsible_area">
								<strong>ÁREA RESPONSABLE</strong>
							</label>
							<validation-provider
								#default="{ errors }"
								rules="required"
								name="Área Responsable"
							>
								<v-select
									id="responsible_area"
									v-model="formData.department"
									:state="errors.length > 0 ? false : null"
									:options="options.departments"
									placeholder="Seleccione"
								/>
								<small class="text-danger">{{ errors[0] }}</small>
							</validation-provider>
						</b-form-group>
					</b-col>

					<b-col
						cols="12"
						class="my-2"
					>
						<b-form-group>
							<label for="indicator">
								<strong>INDICADOR</strong>
							</label>
							<validation-provider
								#default="{ errors }"
								rules="required"
								name="Indicador"
							>
								<v-select
									id="indicator"
									v-model="formData.indicator"
									:state="errors.length > 0 ? false : null"
									:options="options.indicators"
									placeholder="Seleccione"
								/>
								<small class="text-danger">{{ errors[0] }}</small>
							</validation-provider>
						</b-form-group>
					</b-col>

					<b-col
						cols="12"
						class="my-2"
					>
						<b-form-group>
							<label for="performance_groups">
								<strong>GRUPO(S) EDD</strong>
							</label>
							<validation-provider
								#default="{ errors }"
								rules="required"
								name="Grupo(s) EDD"
							>
								<v-select
									id="performance_groups"
									v-model="formData.performance_groups"
									:state="errors.length > 0 ? false : null"
									:options="options.performanceGroups"
									placeholder="Seleccione"
									multiple
								/>
								<small class="text-danger">{{ errors[0] }}</small>
							</validation-provider>
						</b-form-group>
					</b-col>
				</b-form>
			</validation-observer>
			<template #modal-footer>
				<div>
					<b-button-loading
						text="GUARDAR CAMBIOS"
						@process-action="saveResponsibleArea"
						:processing="processing"
					/>
				</div>

				<b-button
					v-ripple.400="'rgba(186, 191, 199, 0.15)'"
					type="button"
					variant="outline-secondary"
					class="ml-2"
					@click="closeResponsibleAreaModal"
				>CERRAR</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import useNotifications from "@notifications"
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { formatStringToDate } from "@core/utils/filter"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { required } from "@validations"
import Ripple from "vue-ripple-directive"
import responsibleAreaStoreModule from "../responsibleAreaStoreModule"
import useResponsibleAreasList from "./useResponsibleAreasList"
import BButtonLoading from "@core/components/b-button-loading/BButtonLoading.vue"
import VueSweetalert2 from "vue-sweetalert2"
import vSelect from "vue-select"
import store from "@/store"
import axios from "@axios"
import Vue from "vue"
import "animate.css"

Vue.use(VueSweetalert2)

export default {
	components: {
		ValidationProvider,
		ValidationObserver,

		BButtonLoading,
		vSelect,
		required
	},
	directives: {
		Ripple
	},
	setup() {
		// USE TOAST
		const { swalNotification, toastNotification } = useNotifications()

		// REFS
		const refForm = ref(null)
		const options = ref({})
		const processing = ref(false)
		const refAssignResponsibleAreaModal = ref(null)
		const formData = ref({
			id: null,
			department: null,
			indicator: null,
			performance_groups: []
		})

		const CONTRACT_APP_STORE_MODULE_NAME = "app-responsible-area"

		// REGISTER MODULE
		if (!store.hasModule(CONTRACT_APP_STORE_MODULE_NAME))
			store.registerModule(
				CONTRACT_APP_STORE_MODULE_NAME,
				responsibleAreaStoreModule
			)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(CONTRACT_APP_STORE_MODULE_NAME))
				store.unregisterModule(CONTRACT_APP_STORE_MODULE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const openAssignResponsibleAreaModal = (is_edit = false, data = {}) => {
			if (is_edit) {
				const performance_groups = []

				if (data.has_mineras) {
					performance_groups.push({ ...options.value.performanceGroups[0] })
				}
				if (data.has_conexas) {
					performance_groups.push({ ...options.value.performanceGroups[1] })
				}

				const department = options.value.departments.find(
					(item) => item.value === data.department_id
				)
				const indicator = options.value.indicators.find(
					(item) => item.value === data.indicator_id
				)

				formData.value = {
					id: data.id,
					department,
					indicator,
					performance_groups
				}
			}

			refAssignResponsibleAreaModal.value.show()
		}

		const closeResponsibleAreaModal = () => {
			refAssignResponsibleAreaModal.value.hide()
			processing.value = false
			formData.value = {
				id: null,
				department: null,
				indicator: null,
				performance_groups: []
			}
		}

		const getSelectFilters = async () => {
			try {
				const [departments, indicators, performanceGroups] = await Promise.all([
					axios.get("/selectors/departments"),
					axios.get("/selectors/indicators"),
					axios.get("/selectors/performance-groups")
				])
				options.value = {
					...departments.data,
					...indicators.data,
					...performanceGroups.data
				}
			} catch (error) {
				toastNotification("Error al cargar datos de selección", false)
			}
		}

		const saveResponsibleArea = async () => {
			processing.value = true

			const isValid = await refForm.value.validate()

			if (!isValid) {
				toastNotification("Complete los campos requeridos", false)
				processing.value = false
				return
			}

			const performance_groups = formData.value.performance_groups.map(
				(item) => item.value
			)

			const payload = {
				department_id: formData.value.department.value,
				indicator_id: formData.value.indicator.value,
				performance_groups
			}

			let id = null
			let action = "createResponsibleArea"
			let queryParams = { payload }

			if (formData.value.id) {
				id = formData.value.id
				action = "updateResponsibleArea"
				queryParams = { id, payload }
			}

			store
				.dispatch(`app-responsible-area/${action}`, queryParams)
				.then((response) => {
					refetchData()
					swalNotification(response.data.message)
					closeResponsibleAreaModal()
				})
				.catch((error) => {
					const message =
						error.response.data.message || "Error al guardar cambios"
					swalNotification(message, false)
				})
				.finally(() => {
					processing.value = false
				})
		}

		const deleteResponsibleArea = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de eliminar el área responsable?",
				html: "<small>¡Si no lo está, puede cancelar la acción!</small>",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, eliminar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-responsible-area/deleteResponsibleArea", { id })
						.then((response) => {
							refetchData()
							swalNotification(response.data.message)
						})
						.catch((error) => {
							const message =
								error.response.data.message ||
								"Error al eliminar área responsable"
							swalNotification(message, false)
						})
				}
			})
		}

		const {
			fetchResponsibleAreas,
			tableColumns,
			perPage,
			currentPage,
			totalResponsibleAreas,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refResponsibleAreasListTable,
			refetchData
		} = useResponsibleAreasList()

		return {
			fetchResponsibleAreas,
			tableColumns,
			options,
			perPage,
			currentPage,
			totalResponsibleAreas,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refResponsibleAreasListTable,
			refetchData,

			// REFS
			refForm,
			formData,
			processing,
			refAssignResponsibleAreaModal,

			// ACTIONS
			formatStringToDate,
			openAssignResponsibleAreaModal,
			closeResponsibleAreaModal,
			saveResponsibleArea,
			deleteResponsibleArea
		}
	}
}
</script>

<style lang="scss" scoped>
.media {
	align-items: center;
}

.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>